interface SerializedNode {
  type?: string;
  text?: string;
  children?: SerializedNode[];
}

const EMBEDDED_CONTENT_TYPES = new Set([
  'image',
  'divider',
  'pagebreak',
  'horizontalrule',
  'table',
]);

function hasContent(node: SerializedNode): boolean {
  if (typeof node.text === 'string') {
    return node.text.trim().length > 0;
  }

  if (node.type && EMBEDDED_CONTENT_TYPES.has(node.type)) {
    return true;
  }

  return node.children?.some(hasContent) ?? false;
}

export function isRichTextEmpty(value?: string | null): boolean {
  if (!value?.trim()) {
    return true;
  }

  try {
    const state = JSON.parse(value) as { root?: SerializedNode };
    return !state.root || !hasContent(state.root);
  } catch {
    return true;
  }
}
